let language = {
    CRAFT_SHOP_DOWNLOAD_TEMPLATE_ERROR_TITLE: '下载错误',
    CRAFT_SHOP_DOWNLOAD_TEMPLATE_ERROR_CONTENT: '下载模板时发生错误',
    CRAFT_SHOP_DOWNLOAD_TEMPLATE_ERROR_5500003: '模板文件不存在',
    CRAFT_SHOP_UPLOAD_ORDER_ERROR_TITLE: '无效文件格式：',
    CRAFT_SHOP_UPLOAD_ORDER_ERROR_CONTENT: '上传的文件格式不正确（CSV）。请更新后重试。',
    CRAFT_SHOP_UPLOAD_ORDER_ERRORS_CONTENT: '导入订单时发生错误',
    CRAFT_SHOP_UPLOAD_ORDER_ERRORS_5500001: '上传的文件格式不正确（CSV）。请更新后重试。',
    CRAFT_SHOP_UPLOAD_ORDER_ERRORS_5500002: '上传的文件格式不正确（CSV）。请更新后重试。',
    CRAFT_SHOP_UPLOAD_ORDER_ERRORS_5700001: '文件存档失败',
    CRAFT_SHOP_DELETE_ORDER_ITEM_HINT_TITLE: '删除确认',
    CRAFT_SHOP_DELETE_ORDER_ITEM_HINT_CONTENT: '你确定要删除当前订单项吗？',
    CRAFT_SHOP_DELETE_ORDER_ITEM_ERRORS_TITLE: '删除错误',
    CRAFT_SHOP_DELETE_ORDER_ITEM_ERRORS_CONTENT: '删除订单时发生错误',
    CRAFT_SHOP_DELETE_ORDER_ITEM_ERRORS_5500004: '导入已成功，无法删除。',

    CRAFT_SHOP_DELETE_ORDER_HINT_TITLE: '删除确认',
    CRAFT_SHOP_DELETE_ORDER_HINT_CONTENT: '你确定要删除与此订单相关的所有项吗？',
    CRAFT_SHOP_DELETE_ORDER_ERRORS_TITLE: '删除错误',
    CRAFT_SHOP_DELETE_ORDER_ERRORS_CONTENT: '删除订单时发生错误',
    CRAFT_SHOP_DELETE_ORDER_ERRORS_5500005: '订单已成功导入，无法删除。',
    CRAFT_SHOP_DELETE_ALL_ORDER_ITEM_HINT_TITLE: '删除确认',
    CRAFT_SHOP_DELETE_ALL_ORDER_ITEM_HINT_CONTENT: '此操作将永久删除所有订单数据，包括已导入的项。你确定要继续吗？',


    CRAFT_SHOP_DOWNLOAD_TEMPLATE_BTN: '下载模板',
    CRAFT_SHOP_UPLOAD_ORDER_FILE_BTN: '上传订单文件',
    CRAFT_SHOP_IMPORT_HISTORY_BTN: '导入历史记录',
    CRAFT_SHOP_IMPORT_ERRORS_BTN: '导入错误',
    CRAFT_SHOP_IMPORT_FILE_DETAILS_BTN: '导入文件详情',
    CRAFT_SHOP_BACK_TO_CUSTOMER_ORDERS_BTN: '返回客户订单',
    CRAFT_SHOP_BACK_TO_IMPORT_HISTORY_BTN: '返回导入历史',
    CRAFT_SHOP_RETRY_ALL_FAILED_IMPORTS_BTN: '重试所有失败导入项',
    CRAFT_SHOP_DELETE_ALL_FAILED_IMPORTS_BTN: '删除所有失败导入项',
    CRAFT_SHOP_CREATE_NEW_ORDER_BTN: '创建新订单',
    CRAFT_SHOP_REFRESH_BTN: '刷新',

    CRAFT_SHOP_ORDER_INFO_LIST_IMPORT_FILE: '导入文件',
    CRAFT_SHOP_ORDER_INFO_LIST_IMPORT_DATE: '导入日期',
    CRAFT_SHOP_ORDER_INFO_LIST_STATUS: '状态',
    CRAFT_SHOP_ORDER_INFO_LIST_OPERATION: '操作',
    CRAFT_SHOP_ORDER_INFO_LIST_TOTAL: '总计：',
    CRAFT_SHOP_ORDER_INFO_LIST_IMPORT_COMPLETE: '导入完成：',
    CRAFT_SHOP_ORDER_INFO_LIST_FAILED: '失败：',
    CRAFT_SHOP_ORDER_INFO_LIST_AWAITING_IMPORT: '等待导入：',
};

export { language }
